<template>
  <Transition
    enter-active-class="transition ease-out duration-100 transform"
    enter-class="opacity-0 scale-95"
    enter-to-class="opacity-100 scale-100"
    leave-active-class="transition ease-in duration-75 transform"
    leave-class="opacity-100 scale-100"
    leave-to-class="opacity-0 scale-95"
  >
  <div class="duration-300 ease-in-out transition-opacity fixed bottom-0 inset-x-0 inset-y-0 px-4 py-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center z-20" v-show="hasMounted">
    <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-200"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <Transition
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div class="ease-out duration-100 fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-cool-gray-400 opacity-75" @click="finished"></div>
      </div>
    </Transition>
    <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-200"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
    <Transition
      enter-class="sm:opacity-0 translate-y-full sm:translate-y-0 sm:scale-95"
      enter-active-class="ease-out duration-300"
      enter-to-class="sm:opacity-100 translate-y-0 sm:scale-100"
      leave-class="sm:opacity-100 translate-y-0 sm:scale-100"
      leave-active-class="ease-in duration-300"
      leave-to-class="sm:opacity-0 translate-y-full sm:translate-y-0 sm:scale-95"
    >

      <div class="bg-white rounded-lg overflow-y-auto scrollbar shadow-xl transform transition-all sm:max-w-lg sm:w-full fixed inset-x-4 sm:inset-auto bottom-4 max-h-90 flex flex-col max-h-75pct" role="dialog" aria-modal="true" aria-labelledby="modal-headline" v-show="hasMounted">
        <slot :finished="finished"></slot>
      </div>
    </Transition>

  </div>
  </Transition>
</template>
<script>
export default {
  props: {
    goBackTo: {
      required: true
    },
    canGoBack: {
      default: false
    }
  },

  data() {
    return {
      hasMounted: !(this.canGoBack == true)
    }
  },

  mounted() {
    this.hasMounted = true
  },

  beforeRouteLeave(to, from, next) {
    this.hasMounted = false
    next()
  },

  methods: {
    finished() {
      this.canGoBack ? this.$router.go(-1) : this.$router.push(this.goBackTo)
    }
  }
}
</script>
